import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('nx_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 2500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = (all = true) => {
    localStorage.setItem('nx_cookie_consent', all ? 'all' : 'essential');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={`cookie-banner ${visible ? 'cookie-visible' : ''}`}>
      <div className="cookie-content">
        <div className="cookie-icon">🍪</div>
        <div className="cookie-text">
          <strong>Nous utilisons des cookies</strong>
          <p>
            Nexia Digital utilise des cookies pour améliorer votre expérience, analyser le trafic et personnaliser le contenu.
            {' '}
            <Link to="/mentions-legales" onClick={() => setVisible(false)}>En savoir plus</Link>
          </p>
          {showDetails && (
            <div className="cookie-details">
              <div className="cookie-detail-item">
                <div>
                  <strong>🔧 Essentiels</strong>
                  <p>Nécessaires au fonctionnement du site. Toujours actifs.</p>
                </div>
                <span className="cookie-toggle cookie-toggle-on">ON</span>
              </div>
              <div className="cookie-detail-item">
                <div>
                  <strong>📊 Analytiques</strong>
                  <p>Nous aident à comprendre comment vous utilisez le site.</p>
                </div>
                <span className="cookie-toggle">Optionnel</span>
              </div>
              <div className="cookie-detail-item">
                <div>
                  <strong>🎯 Marketing</strong>
                  <p>Utilisés pour vous proposer des publicités pertinentes.</p>
                </div>
                <span className="cookie-toggle">Optionnel</span>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="cookie-actions">
        <button
          className="cookie-btn-details"
          onClick={() => setShowDetails(!showDetails)}
        >
          {showDetails ? 'Masquer' : 'Personnaliser'}
        </button>
        <button className="cookie-btn-essential" onClick={() => accept(false)}>
          Essentiels uniquement
        </button>
        <button className="cookie-btn-accept" onClick={() => accept(true)}>
          <i className="fa-solid fa-check" /> Tout accepter
        </button>
      </div>
    </div>
  );
}
